/*
*
* File JS componente Block Gallery
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import Swiper, { Navigation, Pagination, Lazy } from 'swiper';
Swiper.use([Navigation, Pagination, Lazy]);


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import 'swiper/css';
import 'swiper/css/lazy';

import './block-gallery.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockGallery = () =>
{
    let slidersGallery = document.querySelectorAll('.block-gallery .block-gallery__slider.swiper');
    if(!slidersGallery.length) return;
    
    slidersGallery.forEach(sliderGallery =>
    {    
        let arrowPrev = sliderGallery.querySelector('.swiper-button-prev');
        let arrowNext = sliderGallery.querySelector('.swiper-button-next');

        let pagination = sliderGallery.parentElement.querySelector('.swiper-pagination');

        const swiperGallery = new Swiper(sliderGallery,
        {
            slidesPerView: 1,
            spaceBetween: 0,
            autoHeight: true,
            preloadImages: false,
            lazy:
            {
                loadPrevNext: true,
            },
            navigation: 
            {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            pagination:
            {
                el: pagination,
                clickable: true
            }
        });
    })
}

export default blockGallery;

//--------------------------------------------------------------------//